import { NgModule } from '@angular/core';
import { RouterModule, Routes, UrlSegment } from '@angular/router';
import { LoginRelayComponent } from './login-relay/login-relay.component';
import { SsoCallbackComponent } from './sso-callback/sso-callback.component';

const routes: Routes = [
  {
    path: 'relay',
    component: LoginRelayComponent,
  },
  {
    path: 'callback',
    component: SsoCallbackComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SsoRoutingModule {}

export function callbackRetrun(url: UrlSegment[]) {
  return url.length === 1 && url[0].path.endsWith('.html') ? { consumed: url } : null;
}
